import moment from 'moment';

export default (() => {
     $('#toggle-signup').click(function() {
         
         if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $('.signup .form').slideToggle();
            return;
         }

         $(this).addClass('open');
         $('.signup .form').slideToggle();
     })

    function toggleSignUp(e = false) {
        if(e) {
            e.preventDefault();
        }
        
        if($('#signup-fullName').val() || $('#signup-email').val()) {
            var firstName = $('#signup-fullName').val().indexOf(' ') != -1 ? $('#signup-fullName').val().substring(0, $('#signup-fullName').val().indexOf(' ')) : $('#signup-fullName').val(); 
            var lastName = $('#signup-fullName').val().indexOf(' ') != -1 ? $('#signup-fullName').val().substring($('#signup-fullName').val().indexOf(' ') + 1) : '';
            
            $('#first-name-signup').val(firstName);
            $('#last-name-signup').val(lastName);
            $('#email-signup').val($('#signup-email').val());
            $('#signup-fullName').val('');
            $('#signup-email').val('');
        }

        var wrapper = $('.signup-popup');
        var backdrop = $('#backdrop.signup-popup-control');

        if(wrapper.hasClass('open')) {
            if($(window).width() < 768) {
                wrapper.slideUp();
            }
            wrapper.removeClass('open');
            backdrop.removeClass('active');
            return;
        }

        backdrop.addClass('active');

        if($(window).width() < 768) {
            wrapper.slideDown();
        }

        wrapper.addClass('open');
    }

    $('a[href="#signup-popup"]').click(toggleSignUp);
    $('.signup-popup-control').click(toggleSignUp);

    if($('body.template-offers-all').length || $('body.single-offers').length) {
        $('.signup-popup h3 span').text('Sign up to receive special offers');

        setTimeout(function() {
            if(!sessionStorage.getItem('popup')) {
                toggleSignUp();
                sessionStorage.setItem('popup', 'true');
            }
        }, 30000)
    }

    function sendEmail(event) {
        var data = {
            first_name: '',
            last_name: '',
            email: '',
            anniversary: '',
            date_of_birth: '',
            postcode: '',
            website_origin: window.location.href,
            hotel_id: 86,
        }

        if ( '5274' == event.detail.contactFormId ) {
            var inputs = event.detail.inputs;
 
            for ( var i = 0; i < inputs.length; i++ ) {
                switch (inputs[i].name) {
                    case 'firstName':
                        data.first_name = inputs[i].value;
                        break;
                    case 'lastName':
                        data.last_name = inputs[i].value;
                        break;
                    case 'email':
                        data.email = inputs[i].value;
                        break;
                    case 'birth':
                        data.date_of_birth = moment(inputs[i].value, 'DD-MM-YYYY').format();
                        data.anniversary = moment(inputs[i].value, 'DD-MM-YYYY').format();
                        break;
                    case 'postcode':
                        data.postcode = inputs[i].value;
                        break;
                }
            }

            if( !data.first_name || !data.last_name || !data.email || !data.anniversary || !data.date_of_birth || !data.postcode ) {
                return;
            }

            $.ajax({
                url: '/talkbox.php',
                data: JSON.stringify(data),
                type: 'post',
                contentType: 'application/json',
                success: function(response){
                    if(response == 200) {
                        $('.form-signup .wpcf7-response-output').text('Thank you for your subscription!');
                        return;
                    }

                    if(response == 422) {
                        $('.form-signup .wpcf7-response-output').text('You are already registered!');
                        return;
                    }

                    $('.form-signup .wpcf7-response-output').text('Unexpected error, try again later or contact a admin.');
                },
                error: function(response) {
                    $('.form-signup .wpcf7-response-output').text('Unexpected error, try again later or contact a admin.');
                    console.log(response);
                },
            })
        }
    }

    document.addEventListener( 'wpcf7submit', sendEmail, false );
});



// WEBPACK FOOTER //
// ./scripts/components/signup-bar.js